import React from 'react';
import CapacityIcon from 'views/components/icons/Capacity';
import TabPanel from '../../TabPanel';
import TabPanelContent from '../../TabPanelContent';
import CapacityTable from './CapacityTable';

const CapacityTabPanel = ({ metro, capacityConfiguration }) => {
  const title = 'Capacity';
  const icon = <CapacityIcon width={20} height={20} color="black" />;

  const sideSection = !metro.capacity && <span data-testid={'not-available'}>not available at this location</span>;
  return (
    <TabPanel icon={icon} sideSection={sideSection} title={title} productAvailable={!!metro.capacity} initOpen={!!metro.capacity}>
      <TabPanelContent>{!!metro.capacity && <CapacityTable metro={metro} capacityConfiguration={capacityConfiguration} />}</TabPanelContent>
    </TabPanel>
  );
};

export default CapacityTabPanel;
